import { authLoadingManager } from '../loader/auth-loading-manager';

class AuthReloadDetector {
  private static instance: AuthReloadDetector;
  private isReloadingAfterClear = false;

  private constructor() {
    this.checkForReloadAfterClear();
  }

  public static getInstance(): AuthReloadDetector {
    if (!AuthReloadDetector.instance) {
      AuthReloadDetector.instance = new AuthReloadDetector();
    }
    return AuthReloadDetector.instance;
  }

  private checkForReloadAfterClear(): void {
    // Check if this is a reload after clearing tokens
    const wasCleared = sessionStorage.getItem('tokensCleared');
    const hasNoTokens = !localStorage.getItem('AccessToken') && !localStorage.getItem('loginData');
    
    if (wasCleared && hasNoTokens) {
      this.isReloadingAfterClear = true;
      // Start auth loading
      authLoadingManager.startAuthCheck('app-init');
      
      // Clear the flag
      sessionStorage.removeItem('tokensCleared');
      
      // Stop loading after 60 seconds to give users plenty of time to see the smooth animation
      setTimeout(() => {
        authLoadingManager.stopAuthCheck();
        this.isReloadingAfterClear = false;
      }, 60000);
    }
  }

  public markTokensCleared(): void {
    sessionStorage.setItem('tokensCleared', 'true');
  }

  public isReloadingAfterTokenClear(): boolean {
    return this.isReloadingAfterClear;
  }
}

export const authReloadDetector = AuthReloadDetector.getInstance();
